import React, { useState } from 'react';
import { Card, CardHeader, Collapse, CardBody } from 'reactstrap';
import { ReactComponent as Chevron } from '../../../assets/images/arrow-cheveron-down.svg';
import styles from './Accordion.module.css';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';

const Accordion = ({
    id,
    question,
    answer, // ANSWER MAY BE A SINGLE STRING OR REACT ELEMENT OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
    noBodyPadding = false // CAN BE USED TO REMOVE PADDING IN THE ACCORDION BODY OR ANSWER SECTION
}) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Card className={styles.questionCard}>
            <Button
                className={`rounded-0 ${styles.cardHeader}`}
                onClick={() => setIsOpen(!isOpen)}
                name='general0'
            >
                <div
                    className={styles.accordionFaq}
                    title='opens a accordian'
                    role='button'
                >
                    <div className={styles.question}>
                        <p>{id}</p>
                        <p>{question}</p>
                    </div>
                    <Chevron className={classNames(styles.arrow, isOpen ? styles.active : styles.closed)} />
                </div>
            </Button>
            <Collapse
                isOpen={isOpen}
                aria-labelledby='Q1'
                role='region'
            >
                <CardBody className={noBodyPadding ? `${styles.answer} p-0` : styles.answer}>
                    {/* HANDLE EITHER STRING OR ARRAY OF STRINGS AS ANSWER  */}
                    {typeof answer === 'string' ? (
                        <p>{answer}</p>
                    ) : Array.isArray(answer) ? (
                        answer.map((a) => <p>{a}</p>)
                    ) : (
                        answer
                    )}
                </CardBody>
            </Collapse>
        </Card>
    );
};
export default Accordion;
